import "./About.css";
import React, { useContext } from "react";
import {
  Container,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  CardActions,
  Button,
  Icon,
} from "@mui/material";
import MenuBookRoundedIcon from "@mui/icons-material/MenuBookRounded";
import SchoolRoundedIcon from "@mui/icons-material/SchoolRounded";
import AccessTimeFilledRoundedIcon from "@mui/icons-material/AccessTimeFilledRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";
import SportsRoundedIcon from "@mui/icons-material/SportsRounded";
import HearingDisabledRoundedIcon from "@mui/icons-material/HearingDisabledRounded";
import ResponsiveLayout from "../components/ResponsiveLayout";
import { LanguageContext } from "../context/LanguageContext"; // Import LanguageContext

function About() {
  const { language } = useContext(LanguageContext); // Consume language context

  // English Content
  const enContent = {
    heading: "About ISSAD",
    description:
      "The Institute of Social Science and Development has been established keeping in view the need of developing a concept of working together. It is the dire need of the community to bring all professionals on one platform in order to work on Social Issues and development.",
    cards: [
      {
        icon: <MenuBookRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "ACADEMIC GROWTH",
        description:
          "To act as resource centre for institutions working for promotion, education and training in social sciences",
      },
      {
        icon: <SchoolRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "EDUCATION",
        description:
          "To develop academic programs on the model of continuing education for elder group /working class in the community.",
      },
      {
        icon: (
          <AccessTimeFilledRoundedIcon
            sx={{ fontSize: 40, color: "#1565c0" }}
          />
        ),
        title: "DEVELOPMENT",
        description:
          "To establish institute for advancement and raising standards of professional education in the field of social sciences",
      },
      {
        icon: <StarRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "ADVANCEMENT",
        description:
          "To provide a platform for members and to facilitate dissemination of information, making available the course materials",
      },
      {
        icon: <SportsRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "PHYSICAL DEVELOPMENT",
        description:
          "To promote and develop centres for sports and sporting activities and encourage talent fields, grounds and other facilities and amenities",
      },
      {
        icon: (
          <HearingDisabledRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />
        ),
        title: "CHALLENGES",
        description:
          "Training to the persons who are mute, deaf, dumb or blind, crippled or otherwise physically or mentally handicapped. To establish institute for advancement and raising standards of professional education",
      },
    ],
  };

  // Urdu Content (You will need to replace these with actual Urdu translations)
  const urContent = {
    heading: "عن اِصاد", // About ISSAD in Urdu
    description:
      "انسٹی ٹیوٹ آف سوشل سائنس اینڈ ڈویلپمنٹ کو باہمی تعاون کے تصور کو فروغ دینے کی ضرورت کے پیش نظر قائم کیا گیا ہے۔ یہ معاشرے کی اشد ضرورت ہے کہ تمام پیشہ ور افراد کو ایک پلیٹ فارم پر لایا جائے تاکہ سماجی مسائل اور ترقی پر کام کیا جا سکے۔", // Translated description
    cards: [
      {
        icon: <MenuBookRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "تعلیمی ترقی", // Academic Growth in Urdu
        description:
          "سوشل سائنسز میں فروغ، تعلیم اور تربیت کے لیے کام کرنے والے اداروں کے لیے ایک وسائل کے مرکز کے طور پر کام کرنا", // Translated description
      },
      {
        icon: <SchoolRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "تعلیم", // Education in Urdu
        description:
          "معاشرے میں بزرگ افراد/کام کرنے والے طبقے کے لیے جاری تعلیم کے ماڈل پر تعلیمی پروگرام تیار کرنا۔", // Translated description
      },
      {
        icon: (
          <AccessTimeFilledRoundedIcon
            sx={{ fontSize: 40, color: "#1565c0" }}
          />
        ),
        title: "ترقی", // Development in Urdu
        description:
          "سوشل سائنسز کے شعبے میں پیشہ ورانہ تعلیم کے معیار کو بہتر بنانے اور ترقی دینے کے لیے ایک ادارہ قائم کرنا", // Translated description
      },
      {
        icon: <StarRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "فروغ", // Advancement in Urdu
        description:
          "ممبران کے لیے ایک پلیٹ فارم فراہم کرنا اور معلومات کی ترسیل کو آسان بنانا، کورس کے مواد کو دستیاب کرنا", // Translated description
      },
      {
        icon: <SportsRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />,
        title: "جسمانی ترقی", // Physical Development in Urdu
        description:
          "کھیلوں اور کھیلوں کی سرگرمیوں کے مراکز کو فروغ دینا اور تیار کرنا اور ٹیلنٹ فیلڈز، گراؤنڈز اور دیگر سہولیات اور سہولیات کی حوصلہ افزائی کرنا", // Translated description
      },
      {
        icon: (
          <HearingDisabledRoundedIcon sx={{ fontSize: 40, color: "#1565c0" }} />
        ),
        title: "چیلنجز", // Challenges in Urdu
        description:
          "گونگے، بہرے، گونگے یا نابینا، معذور یا کسی اور طرح سے جسمانی یا ذہنی طور پر معذور افراد کو تربیت دینا۔ پیشہ ورانہ تعلیم کے معیار کو بہتر بنانے اور ترقی دینے کے لیے ایک ادارہ قائم کرنا", // Translated description
      },
    ],
  };

  const content = language === "en" ? enContent : urContent;

  return (
    <ResponsiveLayout>
      <Container sx={{ py: 5 }}>
        <Typography
          data-tts="true"
          className="about-heading"
          variant="h3"
          textAlign={"center"}
          gutterBottom
        >
          {content.heading}
        </Typography>
        <Box className="about-container">
          <Typography
            className="about-description"
            variant="body1"
            data-tts="true"
          >
            {content.description}
          </Typography>
          <br></br>
          <br></br>

          <Grid container spacing={3} className="cards-grid">
            {content.cards.map((card, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                {" "}
                {/* Added key prop for list items */}
                <Card className="about-card">
                  <CardContent>
                    {card.icon}
                    <br></br>
                    <br></br>
                    <Typography variant="h6" gutterBottom data-tts="true">
                      {card.title}{" "}
                    </Typography>
                    <Typography variant="body2" data-tts="true">
                      {card.description}
                    </Typography>
                  </CardContent>
                  <CardActions></CardActions>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </ResponsiveLayout>
  );
}

export default About;
